import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdBaseComponent } from '../pvd-base-component/pvd-base-component.js';

var FieldKeyFieldsRequired;
(function (FieldKeyFieldsRequired) {
    FieldKeyFieldsRequired["some"] = "some";
    FieldKeyFieldsRequired["most"] = "most";
    FieldKeyFieldsRequired["all"] = "all";
})(FieldKeyFieldsRequired || (FieldKeyFieldsRequired = {}));
var FieldKeyFieldsRequiredText;
(function (FieldKeyFieldsRequiredText) {
    FieldKeyFieldsRequiredText["some"] = "Required field";
    FieldKeyFieldsRequiredText["most"] = "All fields are required unless otherwise noted.";
    FieldKeyFieldsRequiredText["all"] = "All fields are required.";
})(FieldKeyFieldsRequiredText || (FieldKeyFieldsRequiredText = {}));
const DEFAULT_FIELDS_REQUIRED = FieldKeyFieldsRequired.most;
/**
 * Providence Field Key component.
 * @see {@link https://providence.fmr.com/4.x/components/field-key/field-key.html|Field Key documentation}
 */
class PvdFieldKey extends PvdBaseComponent {
    constructor() {
        super(...arguments);
        //#endregion
        // #region LitElement properties
        this.pvdFieldsRequired = DEFAULT_FIELDS_REQUIRED;
        // #endregion
    }
    // #endregion
    // #region LitElement lifecycles
    getIndicatorMessage() {
        const text = this.pvdText ? this.pvdText : FieldKeyFieldsRequiredText[this.pvdFieldsRequired];
        return x `<span class="pvd-field-key__text">${text}</span>`;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-field-key-root`,
            modifierPrefix: 'pvd-field-key',
            modifiers: [
                {
                    condition: this.pvdFieldsRequired !== undefined,
                    className: `fields-required-${this.pvdFieldsRequired}`,
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}">${this.getIndicatorMessage()}</div>`;
    }
}
//#region Component configuration
PvdFieldKey.componentName = 'field-key';
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-fields-required',
        ...PvdBaseComponent.hasChanged(FieldKeyFieldsRequired),
    }),
    __metadata("design:type", String)
], PvdFieldKey.prototype, "pvdFieldsRequired", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-text',
    }),
    __metadata("design:type", String)
], PvdFieldKey.prototype, "pvdText", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-a11y-text',
    }),
    __metadata("design:type", String)
], PvdFieldKey.prototype, "pvdA11yText", void 0);

export { DEFAULT_FIELDS_REQUIRED, FieldKeyFieldsRequired, FieldKeyFieldsRequiredText, PvdFieldKey };
//# sourceMappingURL=pvd-field-key.js.map
